import './Global.scss';
import 'extensions/fasten-header';
import {initializeSelectMenus} from 'extensions/mvt-select/mvt-select';
import {initializeProductPurchase} from 'extensions/product-purchase/product-purchase';
import {TransfigureNavigation} from 'extensions/mega-menu/mega-menu';
import 'extensions/checkmark-list/checkmark-list.scss';
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/bgset/ls.bgset';
import {PageManager} from '@mvps-genesis/bootstrap';
import MiniBasket from 'extensions/mini-basket';
import Stickyfill from 'stickyfilljs';
import {initializeFallbackSrc} from 'extensions/fallback-src/fallback-src';
import ConfirmAction from 'extensions/confirm-action';
import ContinueShopping from 'extensions/continue-shopping';

export default class Global extends PageManager {

	constructor (pageContext) {

		super(pageContext);

		this.initializeHTMLFormValidator();
		this.initMiniModal();
		this.initGTM();

	}

	onReady () {

		const self = this;

		// Unhide
		import('loading-end.scss');

		initializeSelectMenus();
		initializeProductPurchase();
		initializeFallbackSrc();

		/**
		 * Sticky elements polyfill
		 */
		Stickyfill.add(document.getElementsByClassName('js-sticky'));

		/**
		 * Toggle the `is-open` state of the global account box.
		 */
		(function () {
			var trigger = document.querySelector('[data-hook="show-related"]');

			if (trigger) {
				var relatedTarget = document.querySelector('[data-hook="' + trigger.getAttribute('data-target') + '"]');

				trigger.addEventListener('click', function (event) {
					event.preventDefault();
					relatedTarget.classList.toggle('is-open');
				}, false);

				document.addEventListener('mousedown', function (event) {
					if (relatedTarget.classList.contains('is-open')) {
						if (!relatedTarget.contains(event.target) && event.target !== trigger) {
							relatedTarget.classList.toggle('is-open');
							event.preventDefault();
						}
					}
				}, false);

				window.addEventListener('keydown', function (event) {
					if (event.defaultPrevented) {
						return;
					}

					switch (event.key) {
					case 'Escape':
						if (relatedTarget.classList.contains('is-open')) {
							relatedTarget.classList.toggle('is-open');
						}
						break;
					default:
						return;
					}

					event.preventDefault();
				}, true);
			}
		}());

		/**
		 * Initialize the Mini-Basket extension
		 */
		new MiniBasket({
			containerElement: '[data-hook~="mini-basket"]',
			closeElements: '[data-hook~="close-mini-basket"]',
			openElements: '[data-hook~="open-mini-basket"]'
		});

		/**
		 * Initialize continue shopping link
		 */
		new ContinueShopping();

		/**
		 * Initialize the Drop-Down Navigation extension
		 */
		new TransfigureNavigation({
			menu: '[data-hook~="transfigure-navigation"]',
			parentMenuItems: '[data-hook~="has-child-menu"]',
			menuLink: '.c-navigation__link',
			mainMenuOpenButton: '[data-hook~="open-main-menu"]',
			mainMenuCloseButton: '[data-hook~="close-main-menu"]',
			showPreviousMenuButtons: '[data-hook~="show-previous-menu"]'
		});

		/**
		 * Initialize confirm action extension
		 */
		new ConfirmAction();

		/**
		 * Load FOUC stylesheet
		 */
		import('extensions/fouc/fouc.scss');

		this.triggerPrint();

	}

	async initializeHTMLFormValidator () {

		/**
		 * Initialize Inline Form Validations
		 */

		const forms = document.getElementsByClassName('js-form-validator');

		if (forms.length === 0) {
			return;
		}

		const {HTMLFormValidator} = await import('extensions/form-validation');

		forms.forEach(function (form) {
			form.HTMLFormValidator = new HTMLFormValidator({
				formElement: form,
				wrapperSelector: '.c-form-list__item'
			});
		});
	}

	async initMiniModal () {

		/**
		 * Mini Modal
		 */
		// Elements
		const miniModalElements = Array.from(document.querySelectorAll('[data-mini-modal]'));

		if (miniModalElements.length === 0) {
			return;
		}

		// Module
		const {default: minimodal} = await import('extensions/minimodal');

		// Initiate the modal for each element
		miniModalElements.forEach(element => {
			minimodal(element).init();
		});
	}

	triggerPrint () {

		/**
		 *  Launch Printer Dialog
		 */
		const printTriggers = document.getElementsByClassName('js-print-dialog');

		if (printTriggers.length) {
			printTriggers.forEach(element => {
				element.addEventListener('click', function (e) {
					e.preventDefault();
					window.print();
				}, false);
			});
		}

	}

	async initGTM () {

		const {default: GTM} = await import('extensions/gtm');

		const gtm = new GTM(this.pageContext);
		gtm.init();

		// Listen for Print Events
		window.addEventListener('beforeprint', () => {
			gtm.sendEvent({
				action: 'Click',
				category: 'Print',
				label: document.title,
				noninteractionHit: false
			});
		});
	}

}
